// extracted by mini-css-extract-plugin
module.exports = {"modal":"DialogsWrapper_modal__2Xcxv"};